import {maybeResourceData} from '@freckle/resource-status'
import {useIncompleteAssignmentCount} from '@freckle/student/ts/hooks/use-incomplete-assignment-count'
import type {RoutesWithQueryParams} from '.'
import {pathData} from '.'
import {useCurrentTeacher} from '../../components/with-resources/utils'
import {getIsBlockedFromFocusMode} from '../../logic/dashboard'

export function useRouteBlockedDueToFocusMode(path: keyof RoutesWithQueryParams): {
  data: boolean | undefined
} {
  const isPathBlockedByFocusMode = pathData[path].isBlockedByFocusMode

  const {currentTeacher} = useCurrentTeacher()
  const inFocusMode = maybeResourceData(currentTeacher)?.focusMode
  const needsCount = isPathBlockedByFocusMode && inFocusMode === true

  const {data: incompleteAssignmentCount} = useIncompleteAssignmentCount({enabled: needsCount})

  if (inFocusMode === undefined) {
    return {data: undefined}
  }
  if (!needsCount) {
    return {data: false}
  }
  if (incompleteAssignmentCount === undefined) {
    return {data: undefined}
  }
  return {data: getIsBlockedFromFocusMode(incompleteAssignmentCount.count, inFocusMode)}
}
